import React from 'react';
import { Box, Typography } from '@mui/material';
import CartoonButton from '../../CartoonButton.component';
import { SubmittedBadge, labelStyle } from './ClosestNumber.game';

interface Props {
  submitted: boolean;
  onSubmit: (answer: string) => void;
}

const TeamRedBlue: React.FC<Props> = ({ submitted, onSubmit }) => {
  if (submitted) return <SubmittedBadge />;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3, width: '100%', maxWidth: 400 }}>
      <Typography sx={labelStyle}>Pick your team — one team wins randomly!</Typography>
      <Box sx={{ display: 'flex', gap: 3, width: '100%' }}>
        <CartoonButton
          variant="contained"
          onClick={() => onSubmit('Red')}
          fullWidth
          sx={{ background: '#f44336', height: 90, fontSize: '1.4rem', boxShadow: '0 6px 0 rgba(0,0,0,0.4)' }}
        >
          🔴 Team Red
        </CartoonButton>
        <CartoonButton
          variant="contained"
          onClick={() => onSubmit('Blue')}
          fullWidth
          sx={{ background: '#2196f3', height: 90, fontSize: '1.4rem', boxShadow: '0 6px 0 rgba(0,0,0,0.4)' }}
        >
          🔵 Team Blue
        </CartoonButton>
      </Box>
    </Box>
  );
};

export default TeamRedBlue;
